import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.js';

export default function NavBar() {
  const { currentUser } = useAuth();

  return (
    <header className="site-header">
      <Link to="/" className="site-title">Desperate Oasis</Link>
      <nav className="floating-nav">
        <Link to="/online" className="pill-button">Play</Link>
        {currentUser ? (
          <Link to="/account" className="pill-button">Account</Link>
        ) : (
          <Link to="/login" className="pill-button">Login</Link>
        )}
      </nav>
    </header>
  );
}
